export type ThemePreference = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

const STORAGE_KEY = 'theme-preference'

export function loadPreference(): ThemePreference {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'light' || stored === 'dark' || stored === 'system') {
    return stored
  }
  // No saved choice yet → default to dark. The whole UI was designed for the
  // dark/Linear-Pro palette; light-mode is a secondary option.
  return 'dark'
}

export function savePreference(pref: ThemePreference) {
  localStorage.setItem(STORAGE_KEY, pref)
}

export function resolveTheme(pref: ThemePreference, systemDark?: boolean): ResolvedTheme {
  if (pref === 'system') {
    const isDark = systemDark ?? window.matchMedia('(prefers-color-scheme: dark)').matches
    return isDark ? 'dark' : 'light'
  }
  return pref
}

export function applyTheme(theme: ResolvedTheme) {
  document.documentElement.setAttribute('data-theme', theme)
}
